<template>
  <div class="wrapper">
    <BPMNNodeBase :item="item" @updateName="updateName"/>
    <div class="container-fluid mt-2">
      <div class="form-group">
        <label>Absender</label>
        <input type="text" class="form-control" v-model="sender" @blur="updateSender"/>
      </div>
      <div class="form-group">
        <label>Empfänger</label>
        <input type="text" class="form-control" v-model="receiver" @blur="updateReceiver"/>
      </div>
      <div class="form-group">
        <label>CC</label>
        <input type="text" class="form-control" placeholder="info@test.de;;my@info.de" v-model="cclist" @blur="updateCCList"/>
      </div>
      <div class="form-group">
        <label>Betreff</label>
        <input type="text" class="form-control" v-model="subject" @blur="updateSubject"/>
      </div>
      <div class="form-group">
        <label>HTML Template</label>
        <select class="form-control" v-model="htmltype" @change="updateHTML">
          <option value="sys">System</option>
          <option value="url">URL</option>
          <option value="raw">HTML Direkt</option>
        </select>
        <select v-if="htmltype == 'sys'" class="form-control" v-model="htmltemplate" @change="updateHTML">
          <option v-for="m in mailtemplates" :key="m.id" :value="m.id">{{ m.title }}</option>
        </select>
        <input v-else type="text" class="form-control" v-model="html" @blur="updateHTML"/>
      </div>
      <div class="form-group">
        <label>JSON Daten</label>
        <input type="text" class="form-control" v-model="jsondata" placeholder="{...}" @blur="updateJSON"/>
      </div>
      <div class="form-group">
        <label>Anhang</label>
        <input type="text" class="form-control" placeholder="Dateipfad" v-model="filepath" @blur="updateFilePath"/>
      </div>
    </div>
  </div>
</template>

<script>
import BPMNNodeBase from './BPMNNodeBase.vue'
import config from '@/modules/config.js'
import xmlutils from '@/modules/xmlutil.js'
import bpmn from '@/modules/bpmn.js'

export default {
  props: ["item"],
  components: {
    BPMNNodeBase,
  },
  data() {
    return {
      sender: '',
      senderXml: false,
      receiver: '',
      receiverXml: false,
      cclist: '',
      cclistXml: false,
      jsondata: '',
      jsondataXml: false,
      html: '',
      htmlXml: false,
      htmltype: 'sys',
      htmltemplate: '',
      filepath: '',
      filepathXml: false,
      subject: '',
      subjectXml: false,
      mailtemplates: [],
      extensions: false,
    }
  },
  watch: {
    item: function() {
      this.sender    = '';
      this.receiver  = '';
      this.cclist    = '';
      this.jsondata  = '';
      this.html      = '';
      this.htmltype  = 'sys';
      this.filepath  = '';
      this.subject   = '';
      this.newEngineXml = false;
      this.recieverXml = false;
      this.senderXml   = false;
      this.jsondataXml = false;
      this.parseItem();
    }
  },
  mounted() {
    var self = this;
    fetch(config.baseUrl + 'rest/cms/documents?catID=-1&tree=jsonmail&start=0&count=200').then(resp => resp.json()).then(function(values) {
      console.log('values',values);
      for (var i in values) {
        var sub = values[i];
        self.mailtemplates.push(sub);
      }
      console.log('mm',self.mailtemplates);
    });
    this.parseItem();
  },
  methods: {
    parseItem() {
      // check at least childrens
      if (!this.item.children) { this.item.children = []; }

      // get extension child
      this.extensions = xmlutils.jsonxmlchild(this.item,'extensionElements');

      // add if not present
      if (!this.extensions) {
        this.extensions = bpmn.newExtensions();
        this.item.children.push(this.extensions);

      } else if (!this.extensions.children) {
        this.extensions.children = [];
      }

      for (var i in this.extensions.children) {
        var sub = this.extensions.children[i];
        if (sub.localName == 'field') {
          console.log('check fields',sub.attributes.name.value);
          if (sub.attributes.name.value == 'from') {
            this.senderXml = sub;
            this.sender = sub.children[0].children[0].content;
            console.log('sender',this.sender);
          } else if (sub.attributes.name.value == 'to') {
            this.receiverXml = sub;
            this.receiver = sub.children[0].children[0].content;
            console.log('receiver',this.receiver);
          } else if (sub.attributes.name.value == 'cc') {
            this.cclistXml = sub;
            this.cclist = sub.children[0].children[0].content;
          } else if (sub.attributes.name.value == 'json') {
            this.jsondataXml = sub;
            this.jsondata = sub.children[0].children[0].content;
          } else if (sub.attributes.name.value == 'subject') {
            this.subjectXml = sub;
            this.subject = sub.children[0].children[0].content;
          } else if (sub.attributes.name.value == 'filepath') {
            this.filepathXml = sub;
            this.filepath = sub.children[0].children[0].content;
          } else if (sub.attributes.name.value == 'newEngine') {
            this.newEngineXml = sub;
          } else if (sub.attributes.name.value == 'html') {
            this.htmlXml = sub;
            var temp = sub.children[0].children[0].content;
            console.log('got temp html',this.htmlXml);
            if (temp) {
              if (temp.startsWith('sys:')) {
                this.htmltype = 'sys';
                this.htmltemplate = temp.substring(4);
                console.log(this.htmltemplate);
              } else if (temp.startsWith('<')) {
                this.htmltype = 'raw';
                this.html = temp;
              } else {
                this.htmltype = 'url';
                this.html = temp;
              }
            }
          }
        }
      } // check given extensions

      // force new engine
      if (!this.newEngineXml) {
        this.newEngineXml = bpmn.newStringFieldChild();
        this.newEngineXml.attributes.name.value = 'newEngine';
        this.newEngineXml.children[0].children[0].content = '1';
        this.extensions.children.push(this.newEngineXml);
      }
    },
    updateName(e) {
      this.$emit('updateName',e);
    },
    updateSender() {
      console.log('update receiver',this.senderXml);
      if (!this.senderXml) {
        this.senderXml = bpmn.newExpressionChild();
        this.senderXml.attributes.name.value = 'from';
        this.extensions.children.push(this.senderXml);
      }
      this.senderXml.children[0].children[0].content = this.sender;
      console.log('ext len:',this.extensions.children.length);
    },
    updateReceiver() {
      console.log('update receiver',this.receiverXml);
      if (!this.receiverXml) {
        this.receiverXml = bpmn.newExpressionChild();
        this.receiverXml.attributes.name.value = 'to';
        this.extensions.children.push(this.receiverXml);
      }
      this.receiverXml.children[0].children[0].content = this.receiver;
      console.log('update receiver:',this.receiverXml,this.extensions);
      console.log('ext len:',this.extensions.children.length);
    },
    updateCCList() {
      if (!this.cclist || this.cclist == '') {
        //this.extensions.children.remove(this.cclistXml);
        this.cclistXml = false;
        return;
      }
      if (!this.cclistXml) {
        this.cclistXml = bpmn.newExpressionChild();
        this.cclistXml.attributes.name.value = 'cc';
        this.extensions.children.push(this.cclistXml);
      }
      this.cclistXml.children[0].children[0].content = this.cclist;
      console.log('ext len:',this.extensions.children.length);
    },
    updateJSON() {
      if (!this.jsondataXml) {
        this.jsondataXml = bpmn.newExpressionChild();
        this.jsondataXml.attributes.name.value = 'json';
        this.extensions.children.push(this.jsondataXml);
      }
      this.jsondataXml.children[0].children[0].content = this.jsondata || '$procVars';
      console.log('ext len:',this.extensions.children.length);
    },
    updateSubject() {
      if (!this.subjectXml) {
        this.subjectXml = bpmn.newExpressionChild();
        this.subjectXml.attributes.name.value = 'subject';
        this.extensions.children.push(this.subjectXml);
      }
      this.subjectXml.children[0].children[0].content = this.subject;
      console.log('ext len:',this.extensions.children.length);
    },
    updateFilePath() {
      if (!this.filepath) return;
      if (!this.filepathXml) {
        this.filepathXml = bpmn.newExpressionChild();
        this.filepathXml.attributes.name.value = 'filepath';
        this.extensions.children.push(this.filepathXml);
      }
      this.filepathXml.children[0].children[0].content = this.filepath;
      console.log('ext len:',this.extensions.children.length);
    },
    updateHTML() {
      console.log('update html ',this.html,this.htmltemplate);
      if ((this.htmltype !== 'sys' && (!this.html || this.html == ''))) {
        console.log('rem html element')
        this.htmlXml = false;
        return;
      }
      if (!this.htmlXml) {
        this.htmlXml = bpmn.newExpressionChild();
        this.htmlXml.attributes.name.value = 'html';
        this.extensions.children.push(this.htmlXml);
      }
      console.log('html type',this.htmltype);
      if (this.htmltype == 'sys') {
        this.htmlXml.children[0].children[0].content = 'sys:' + this.htmltemplate;
      } else {
        this.htmlXml.children[0].children[0].content = this.html;
      }
      console.log('updated:',this.htmlXml);
      console.log('ext len:',this.extensions.children.length);
    }
  }
}
</script>
